import { defineMessages } from "react-intl";

import {
	hasDiseaseMessages,
	otherSurgicalInterventionTypeMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/otherSurgicalIntervention";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	otherSurgicalIntervention: {
		id: "ktx.form.other_surgical_intervention",
		defaultMessage: "Egyéb sebészeti beavatkozás"
	},
	hasDisease: {
		id: "ktx.form.other_surgical_intervention.hasDisease",
		defaultMessage: "Anamnézis?"
	},
	otherSurgicalInterventionType: {
		id: "ktx.form.other_surgical_intervention.type",
		defaultMessage: "Anamnézis"
	},
	otherSurgicalInterventionTypeOther: {
		id: "ktx.form.other_surgical_intervention.other",
		defaultMessage: "Leírás"
	},
	comment: {
		id: "ktx.form.other_surgical_intervention.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	hasDisease: {
		type: "field",
		path: ["hasDisease"],
		label: messages.hasDisease,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: hasDiseaseMessages }
		}
	},
	otherSurgicalInterventionType: {
		type: "field",
		path: ["diseases", "otherSurgicalInterventionType"],
		label: messages.otherSurgicalInterventionType,
		errorMessages: genericErrorMessages,
		input: {
			type: "checkbox-group",
			props: {
				labels: otherSurgicalInterventionTypeMessages,
				direction: "vertical",
				columns: 2
			}
		}
	},
	otherSurgicalInterventionTypeOther: {
		type: "field",
		path: ["diseases", "otherSurgicalInterventionTypeOther"],
		label: messages.otherSurgicalInterventionTypeOther,
		errorMessages: genericErrorMessages,
		input: {
			type: "textarea",
			props: {}
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [{ width: 12, field: fields.hasDisease }]
		},
		{
			columns: [
				{ width: 12, field: fields.otherSurgicalInterventionType }
			]
		},
		{
			columns: [
				{ width: 12, field: fields.otherSurgicalInterventionTypeOther }
			]
		},
		{
			columns: [{ width: 12, field: fields.comment }]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_otherSurgicalIntervention",
	value: {
		schemaId: "otherSurgicalIntervention",
		title: messages.otherSurgicalIntervention,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
